var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 854 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 480,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M427,410a70,70,0,0,0-70,70H497A70,70,0,0,0,427,410Z",
    fill: "#ff0089"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M427,330A150,150,0,0,0,277,480h70a80,80,0,0,1,160,0h70A150,150,0,0,0,427,330Z",
    fill: "#ff0089"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M427,170c-171.21,0-310,138.79-310,310H267a160,160,0,0,1,320,0H737C737,308.79,598.21,170,427,170Z",
    fill: "#ff0089"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M427,62C196.14,62,9,249.14,9,480H113c0-173.42,140.58-314,314-314S741,306.58,741,480H845C845,249.14,657.86,62,427,62Z",
    fill: "#ff0089",
    opacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepUp);
export default __webpack_public_path__ + "static/media/StepUp.9496428f588195245f7c5305d660f934.svg";
export { ForwardRef as ReactComponent };